module.exports = {"540523100":"桑日镇","540523200":"增期乡","540523201":"白堆乡","540523202":"绒乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540523.json
// module id = 2530
// module chunks = 0